import { AutoComplete } from "primereact/autocomplete";
import { Component, ReactElement } from "react";
import { Pharmacy_ItemList } from "../UserSignup/signup";
import { MapProps } from "../Pharmacy/map-tab/mapTab.component";
import './autocompletePharmacy.css';
import { PharmacyNationalIdNumber_ItemList } from "../AssociateCard/associateCard";
import { getIsOnline } from "../../utilities/common.utilities";
import { ConnectivityContext, ConnectivityContextType } from "../../context/connectivityContext";


export type autocompletePharmacyProps = {
  pharmacies: Pharmacy_ItemList[] | PharmacyNationalIdNumber_ItemList[];
  address: string;
  geoLocationActive: boolean;
  onChangeSelection?: any;
  useInfoCustomer?: boolean;
  panelClassAutocomplete: string;
};

export enum Enum_TypeSuggestion {
    Address = 1,
    Pharmacy = 2
}

type suggestionModel = {
    label: string;
    typeSuggestion: Enum_TypeSuggestion;
    lat: number;
    lng: number;
}

type autocompletePharmacyState = {
    address: string;
    suggestions: suggestionModel[];
    pharmacies: Pharmacy_ItemList[] | PharmacyNationalIdNumber_ItemList[];
    isOnline: boolean;
}

export type autocompletePharmacyOutputModel = {
    typeSuggestion: Enum_TypeSuggestion;
    coord: MapProps;
    label: string;
}

class AutocompletePharmacy extends Component<autocompletePharmacyProps, autocompletePharmacyState> {

  static contextType = ConnectivityContext;  // Associa il contesto al componente
  context!: ConnectivityContextType;  // Tipizza il contesto (la "!" serve per dire a TypeScript che non sarà undefined)

  state: autocompletePharmacyState = {
      address: '',
      suggestions: [],
      pharmacies: this.props.pharmacies,
      isOnline: navigator.onLine
  }

  componentDidMount(): void {

    // getIsOnline().then(s => {
    //   this.setState({isOnline: s})
    // });

    // Aggiorna la variabile di stato connessione il valore dal contesto
    this.setState({ isOnline: this.context.isOnline });
  }

  componentDidUpdate(prevProps: autocompletePharmacyProps, prevState: autocompletePharmacyState) {
    // Se il valore del contesto cambia, aggiorna lo stato
    if (prevState.isOnline !== this.context.isOnline) {
      this.setState({ isOnline: this.context.isOnline });
    }
  }

  componentWillUnmount(): void {}


  async researchAddress(textResearch: string) {

    let data: suggestionModel[] = []; 

    let s = new google.maps.places.AutocompleteService();
    let request: any = {
        input: textResearch,
        componentRestrictions: {country: "it"},
        types: ['locality','route','street_address']
    }

    await s.getPlacePredictions(request,function(response) {
      data = response?.map((x: any) => {
          let s: suggestionModel = {
              label: x.description,
              typeSuggestion: Enum_TypeSuggestion.Address,
              lat: 0,
              lng: 0
          };

          return s;
      });
    })

    return data;
  }

  async createSuggestions(research: string) {
    let listAdresses: suggestionModel[] = [];

    if(this.state.isOnline) {
      listAdresses = await this.researchAddress(research) ?? [];
    }
   
    let newSuggestions: suggestionModel[] = listAdresses.concat(this.searchPharmacies(research));

    this.setState({suggestions: newSuggestions});
  }

  searchPharmacies = (value: string) => {

    let tempPharmacies: Pharmacy_ItemList[] = [];
    if(value) {
       tempPharmacies = this.props.pharmacies?.filter((x) => {
        if (
          x.store?.name?.toLowerCase().includes(value.toLowerCase()) ||
          x.groupName.toLowerCase().includes(value.toLowerCase()) ||
          x.store?.address?.address?.toLowerCase()?.includes(value.toLowerCase()) ||
          x.store?.address?.city
            ?.toString()
            ?.toLowerCase()
            ?.includes(value.toLowerCase()) ||
          x.store?.address?.zipCode
            ?.toString()
            ?.toLowerCase()
            ?.includes(value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    let listSuggestions: suggestionModel[] = tempPharmacies?.map(x => {
        let s: suggestionModel = {
            label: x.store.name,
            typeSuggestion: Enum_TypeSuggestion.Pharmacy,
            lat: x.store.latitude,
            lng: x.store.longitude
        };

        return s;
    })

    return (listSuggestions ? listSuggestions : []);
  };

  optionAddressTemplate(option: suggestionModel, viewDivider: boolean): ReactElement {
    return (
        <div className={ 'flex flex-row align-items-stretch my-1 ' + (viewDivider ? 'lastAddress' : '')}>
            <div className="align-content-center align-items-center justify-content-center">
                <i className="pi pi-map-marker" style={{ fontSize: '1.5rem' }}>
                </i>
            </div>

            <div className="ml-4 align-items-center justify-content-center text-blue-600"
              style={{ marginTop: '2px', textWrap: 'pretty' }}>
                { option.label }
            </div>
        </div>
    )
  }

  optionPharmacyNoCustomerTemplate(option: suggestionModel): ReactElement {
    let pharmacy: Pharmacy_ItemList = this.props.pharmacies.find(f => f.store.name === option.label) as Pharmacy_ItemList;

    return (
      <>

        {/* nome farmacia ed icona */}

        <div className="flex flex-row align-items-stretch">

          <div className="flex flex-column justify-content-center align-items-center">
            <i className="bi bi-fullscreen-exit text-2xl " draggable={false} 
              style={{ width: '1.5rem', height: '1.5rem', color: 'black' }}  />
          </div>

          <div className="flex justify-content-start text-blue-600 ml-4" 
            style={{ whiteSpace: "normal", marginTop: '2px' }}>
            <strong> {pharmacy.store.name} </strong>
          </div>
        </div>

        {/* gruppo */}

        <div className="flex flex-row align-items-stretch mt-2">

          <div style={{ width: '1.5rem' }}></div>

          <div className="flex justify-content-start text-blue-600" style={{ whiteSpace: "normal" }}>
            <small className="ml-1 ml-5">
              Gruppo: <strong>{pharmacy.groupName}</strong>{" "}
            </small>
          </div>
        </div>

        {/* Distanza ed indirizzo */}

        <div className="flex flex-row align-items-stretch mt-2">

          <div style={{ width: '1.5rem' }} className="flex align-items-center justify-content-center">
            {
              this.props.geoLocationActive
              ?
              <div className="ml-1 border-round flex justify-content-end" 
                  style={{ color: 'white', backgroundColor: '#48aa8f', border: '1px solid #797979', minWidth: '48px' }}>
                  <div className="flex align-items-center justify-content-center p-1">
                    <span style={{ fontSize: '11px', fontWeight: 'bold' }}> { pharmacy.distanceFromPosition } </span>
                    <span style={{ fontSize: '9px', marginLeft: '4px' }}>Km</span>
                </div>
               </div>
              : <></>
            }
          </div>

          <div
        className="flex flex-column justify-content-start ml-5 text-blue-600"
        style={{ whiteSpace: "normal" }}
      >
        {pharmacy.store.address.address ? (
          <div>
            <small> {pharmacy.store.address.address} </small>
          </div>
        ) : (
          ""
        )}

        <small>
          {(pharmacy.store.address.zipCode
            ? pharmacy.store.address.zipCode + " "
            : "") +
            (pharmacy.store.address.city
              ? pharmacy.store.address.city + " "
              : "")}
        </small>
        

      </div>
        </div>
      </>
    )
  }

  optionPharmacyCustomerTemplate(option: suggestionModel): ReactElement {

    let pharmacy: PharmacyNationalIdNumber_ItemList = this.props.pharmacies.find(f => f.store.name === option.label) as PharmacyNationalIdNumber_ItemList;
 
    return (
      <>

        {/* nome farmacia ed icona */}

        <div className="flex flex-row align-items-stretch">

          <div className="flex flex-column justify-content-center align-items-center">
            <i className="bi bi-fullscreen-exit text-2xl " draggable={false} 
              style={{ width: '1.5rem', height: '1.5rem', color: 'black' }}  />
          </div>

          <div className="flex justify-content-start text-blue-600 ml-4" 
            style={{ whiteSpace: "normal", marginTop: '3px' }}>
            <strong> {pharmacy.store.name} </strong>
          </div>
        </div>

        {/* gruppo */}

        <div className="flex flex-row align-items-stretch mt-2">

          <div style={{ width: '1.5rem' }}></div>

          <div className="flex justify-content-start text-blue-600" style={{ whiteSpace: "normal" }}>
            <small className="ml-1 ml-5">
              Gruppo: <strong>{pharmacy.groupName}</strong>{" "}
            </small>
          </div>
        </div>

        {/* Distanza ed indirizzo */}

        <div className="flex flex-row align-items-stretch mt-2">

          <div style={{ width: '1.5rem' }} className="flex align-items-center justify-content-center">
            {
              this.props.geoLocationActive
              ?
              <div className="ml-1 border-round flex justify-content-end" 
              style={{ color: 'white', backgroundColor: '#48aa8f', border: '1px solid #797979', minWidth: '48px' }}>
              <div className="flex align-items-center justify-content-center p-1">
                <span style={{ fontSize: '11px', fontWeight: 'bold' }}> { pharmacy.distanceFromPosition } </span>
                <span style={{ fontSize: '9px', marginLeft: '4px', marginTop: '0.5px' }}>Km</span>
            </div>
           </div>
              : <></>
            }
          </div>

          <div
        className="flex flex-column justify-content-start ml-5 text-blue-600"
        style={{ whiteSpace: "normal" }}
      >
        {pharmacy.store.address.address ? (
          <div>
            <small> {pharmacy.store.address.address} </small>
          </div>
        ) : (
          ""
        )}

        <small>
          {(pharmacy.store.address.zipCode
            ? pharmacy.store.address.zipCode + " "
            : "") +
            (pharmacy.store.address.city
              ? pharmacy.store.address.city + " "
              : "")}
        </small>
        

      </div>
        </div>

        {
        pharmacy.customerIsRegistered
        ?
             <div className="flex flex-row align-items-stretch mt-3">

        <div className="flex flex-column justify-content-center align-items-center"
          style={{ width: '1.5rem' }}>
            <i className="pi pi-user text-color-secondary" style={{ fontSize: '0.9rem' }} />
        </div>

        <div className="ml-4">

        {
               pharmacy.customerIsRegistered
               ?
               <span className="mt-3 text-600 font-italic text-sm">
                 Cliente già censito.<br />
                 Seleziona per associare i dati all'account.
               </span>
               :
               <></>
        }

        </div>


      </div>
        :
        <></>
      }
            
      </>
    );
  }

  pharmacyOptionTemplate = (option: suggestionModel,index: number): ReactElement => {
    if(option.typeSuggestion === Enum_TypeSuggestion.Address) {

      let countAddress: number | undefined = this.state.suggestions?.filter(x => x.typeSuggestion === Enum_TypeSuggestion.Address)?.length;
      let countPharmacies: number | undefined = this.state.suggestions?.filter(x => x.typeSuggestion === Enum_TypeSuggestion.Pharmacy)?.length;
      let isLastAddress: boolean = ((index === countAddress -1) && countAddress > 0 && countPharmacies > 0)

      let viewDivider: boolean = isLastAddress && countPharmacies > 0;
      return this.optionAddressTemplate(option, viewDivider);
    }
    else {
      if(!this.props.useInfoCustomer) {
        return this.optionPharmacyNoCustomerTemplate(option);
      }
      else {
        return this.optionPharmacyCustomerTemplate(option);
      }
    }
  }

  // funzione richiamata quando viene digitato un carattere oppure quando viene effettuata una scelta
  // dal menù a tendina
  onChange(value: string | suggestionModel): void {

    // Se value è di tipo Stringa, vuol dire che l' evento è stato scatenato da tastiera 
    if(typeof(value) === 'string') {
        this.setState({address: value})  // perciò aggiorno lo state legato al valore dell' input
    }
    // Altrimenti vuol dire che l' evento è stato scatenato dalla selezione dell' autocomplete
    else {
        // console.log(value)
        let output: autocompletePharmacyOutputModel = {
            typeSuggestion: value.typeSuggestion,
            coord: {lat: value.lat, lng: value.lng},
            label: value.label
        }

        this.props.onChangeSelection(output)
        this.setState({address: ''})
        // if(value.typeSuggestion === Enum_TypeSuggestion.Pharmacy) {
        //     this.setState({address: ''})
        // }
        // else {
        //     this.setState({address: value.label})
        // }

        setTimeout(() => {
          document.getElementById('autocomplete_pharmacy_input')?.blur();
        })
    }
  }

  onPressEnterKey(): void {
    if(this.state.suggestions.length > 0) {
      let firstSuggestion: suggestionModel = this.state.suggestions[0];

      let output: autocompletePharmacyOutputModel = {
        typeSuggestion: firstSuggestion.typeSuggestion,
        coord: {lat: firstSuggestion.lat, lng: firstSuggestion.lng},
        label: firstSuggestion.label
      }

      this.props.onChangeSelection(output)
      this.setState({address: ''})

      
      setTimeout(() => {
        document.getElementById('autocomplete_pharmacy_input')?.blur();
      })

    }
  }

  render() {

    return (
        <div className="relative w-full autocomplete-pharmacy">
          <AutoComplete 
              field="label"
              type="search"
              inputId="autocomplete_pharmacy_input"
              value={this.state.address}
              placeholder="Cerca farmacia o indirizzo..."
              loadingIcon="pi pi-spin pi-spinner loading-icon-autocomplete"
              delay={500}
              suggestions={this.state.suggestions}
              
              onChange={(e) => this.onChange(e.target.value) }
              onKeyPress={(e) => {
                if(e.key === 'Enter') {
                  this.onPressEnterKey();
                }
              }}

              completeMethod={(e) => this.createSuggestions(e.query)}

              panelClassName={this.props.panelClassAutocomplete}
              itemTemplate={this.pharmacyOptionTemplate}
          />
        </div>
    )
  }
}

export default AutocompletePharmacy;
